/* IMPORT
-------------------------------------------------------------- */
import {
  // SVG
  dashboardIcon,
  invoicesIcon,
  partnerIcon,
  customerIcon,
  offersIcon,
  ordersIcon,
  settingsIcon,
  addItemIcon,
  invoiceIcon,
  commissionIcon,
  calendarTimeIcon,
  warningIcon,
} from '@deanone/dean-components';

/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '../../router';

Vue.use(Vuex, VueAxios, axios);

export interface HeaderItem {
  name: string;
  icon: string;
  title: string;
  url: string;
  privileges: any;
  state: string;
}

export const requestHeader = (context: any) => {

  let general = {
    dashboard: {
      name: 'dashboard',
      icon: dashboardIcon,
      title: 'Dashboard',
      url: '/dashboard',
      privileges: [],
      state: 'not-active',
    },
    partners: {
      name: 'partners',
      icon: partnerIcon,
      title: 'Partners',
      url: '/partners',
      privileges: ['view-partner'],
      state: 'not-active',
    },
    customers: {
      name: 'klanten',
      icon: customerIcon,
      title: 'Klanten',
      url: '/klanten',
      privileges: ['view-customer'],
      state: 'not-active',
    },
    quotes: {
      name: 'quotes',
      icon: offersIcon,
      title: 'Offertes',
      url: '/quotes',
      privileges: ['view-quote'],
      state: 'not-active',
    },
    orders: {
      name: 'orders',
      icon: ordersIcon,
      title: 'Orders',
      url: '/orders',
      privileges: ['view-order'],
      state: 'not-active',
    },
    orderlines: {
      name: 'orderlines',
      icon: ordersIcon,
      title: 'Orderregels',
      url: '/orderlines',
      privileges: ['view-orderline'],
      state: 'not-active',
    },
    invoices: {
      name: 'invoices',
      icon: invoicesIcon,
      title: 'Facturen',
      url: '/invoices',
      privileges: ['view-invoice'],
      state: 'not-active',
    },
    standingData: {
      name: 'stamgegevens',
      icon: settingsIcon,
      title: 'Instellingen',
      url: '/stamgegevens',
      privileges: ['view-settings'],
      state: 'not-active',
      children: {
        products: {
          title: 'Producten',
          icon: addItemIcon,
          name: 'standingData.products',
        },
        provisioningServices: {
          title: 'Services',
          icon: addItemIcon,
          name: 'standingData.provisioningServices',
        },
        groups: {
          title: 'Groepen',
          icon: addItemIcon,
          name: 'standingData.groups',
        },
        odidoProducts: {
          title: 'Odido',
          icon: addItemIcon,
          name: 'standingData.odidoProducts',
        },
        kpnProducts: {
          title: 'KPN',
          icon: addItemIcon,
          name: 'standingData.kpnProducts',
        },
        pricePlans: {
          title: 'Prijsplannen',
          icon: invoiceIcon,
          name: 'standingData.pricePlans',
        },
        recurringCommissionPlans: {
          title: 'Periodieke Commissieplannen',
          icon: commissionIcon,
          name: 'standingData.recurringCommissionPlans',
        },
        partnerTypes: {
          title: 'Partner Types',
          icon: partnerIcon,
          name: 'standingData.partnerTypes',
        },
        productTerms: {
          title: 'Product termijnen',
          icon: calendarTimeIcon,
          name: 'standingData.productTerms',
        },
        logs: {
          title: 'Logboeken',
          icon: warningIcon,
          name: 'standingData.logs',
        },
        queueMonitor: {
          title: 'Queue Monitor',
          icon: warningIcon,
          name: 'standingData.queueMonitor',
        },
      },
    },
  };

  general = checkPrivileges(context, general);
  checkState(general);

  const items: any = {
    general,
  };

  context.commit('SET_HEADER', items);
};

export const updateSideMenu = (context: any, sideMenu: any) => {
  context.commit('SET_SIDEMENU', sideMenu);
};

export const checkState = (items: any) => {
  // @ts-ignore
  const currentRoutePath = router.history.current.fullPath;

  const pathSlashes = [...currentRoutePath.matchAll('/')];
  const firstSlashInPath = pathSlashes[0].index + 1;
  const nextSlashInPath = pathSlashes[1].index;

  const navigationSectionFromCurrentRoutePath = currentRoutePath.slice(
    firstSlashInPath,
    nextSlashInPath,
  );

  Object.entries(items).forEach((item: any) => {
    const mainNavigationItem = items[item[0]];

    mainNavigationItem.state = (mainNavigationItem.name === navigationSectionFromCurrentRoutePath)
      ? 'active'
      : 'not-active';
  });
};

export const checkPrivileges = (context: any, items: any) => {
  const allowedItems: any = {};
  const user: any = context.getters.getUser;
  const keys: any = Object.keys(items);

  const intersect = (a: any, b: any) => {
    if (!a || !b) {
      return [];
    } else {
      let t;
      if (b.length > a.length) {
        t = b;
        b = a;
        a = t;
      }
      return a.filter((e: any) => {
        return b.indexOf(e) > -1;
      });
    }
  };

  for (let i = 0; i < Object.keys(items).length; i++) {
    if ((items as HeaderItem[])[keys[i]].privileges.length === 0) {
      allowedItems[keys[i]] = items[keys[i]];
    } else {
      const test = intersect(context.getters.getUser.privileges, items[keys[i]].privileges);
      if (test.length > 0) {
        allowedItems[keys[i]] = items[keys[i]];
      }
    }
  }

  return allowedItems;
};
